exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-22901cdd] .el-form-item__content{width:1.45833rem}\n", ""]);

// exports
